import type { FC, PropsWithChildren, ReactNode } from 'react';

import { iconListRecipe } from './IconList.css';
import { IconListItem } from './IconListItem';
import { RecipeVariants } from '../../vanilla-extract.css';

export type IconListVariants = RecipeVariants<typeof iconListRecipe>;

type Props = {
  /** IconList.Item components */
  children: ReactNode;
  alignment?: 'top' | 'middle' | 'bottom';
};

const IconListComponent: FC<PropsWithChildren<Props>> = ({ children, alignment }) => {
  return <ul className={iconListRecipe({ alignment })}>{children}</ul>;
};

export const IconList = Object.assign(IconListComponent, { Item: IconListItem });
